import { getEvents } from "../../frameworks/mz-wp-api";

const toolTipConfig = {
    items: "td[title]",
    position: {
        my: "center bottom-20",
        at: "center top",
        using: function (position, feedback) {
            $(this).css(position);
            $("<div>").addClass("arrow").addClass(feedback.vertical).addClass(feedback.horizontal).appendTo(this);
        },
    },
    delay: 4000,
    effect: "slide",
    content: function () {
        var element = $(this);
        if (element.is("td[title]")) {
            // console.log('element : ' + element.html());
            var ret = element.attr("title");
            if (ret == "") {
                return element;
            } else {
                return "<div>" + ret + "</div>";
            }
        } else {
            console.error("Tooltip error", this);
        }
    },
};
const initialDate = new Date();

let calendarBody = {
    action: "getEvents",
    status: "all",
    posts_per_page: -1,
    date_query: JSON.stringify({
        after: {
            year: initialDate.getFullYear(),
            month: initialDate.getMonth(),
        },
        before: {
            year: new Date(initialDate.getFullYear(), initialDate.getMonth() + 3).getFullYear(),
            month: new Date(initialDate.getFullYear(), initialDate.getMonth() + 3).getMonth(),
        },
        inclusive: true,
    }),
};

let currEvents = {};

// function setCalendarEvents(newEvents) {
//     newEvents.forEach((event) => {
//         if (!event.company.shortName) return;
//         let formated = new Date(event.eventDate).toLocaleString("en", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });
//         if (currEvents[formated]) {
//             if (!currEvents[formated].includes(event.company.shortName)) {
//                 currEvents[formated].push(event.company.shortName);
//             }
//         } else {
//             currEvents[formated] = [event.company.shortName];
//         }
//     });
// }

function setCalendarEvents(newEvents) {
    newEvents.forEach((event) => {
        // Obtendo nome da empresa, se existir
        // let companyName = event.company && event.company.shortName ? event.company.shortName : "Evento sem empresa";
        let companyName = `<span class="company">${event.title}</span>`;
        // Formatando a data para 'dd/MM/yyyy'
        let date = new Date(event.eventDate);
        let day = String(date.getUTCDate()).padStart(2, "0");
        let month = String(date.getUTCMonth() + 1).padStart(2, "0");
        let year = date.getUTCFullYear();
        let formated = `${day}/${month}/${year}`;
        
        // console.log('evento: ', formated, event)
        // Adicionando o evento no currEvents
        if (currEvents[formated]) {
            if (!currEvents[formated].includes(companyName)) {
                currEvents[formated].push(companyName);
            }
        } else {
            currEvents[formated] = [companyName];
        }
    });
}

getEvents(calendarBody).then((res) => {
    // console.log('calendario: ', res)
    const calEvents = res.posts;

    setCalendarEvents(calEvents);

    const datepickerArgs = {
        inline: true,
        numberOfMonths: 3,
        onSelect: (date, inst) => {},
        dayNamesMin: lang == "en" ? ["S", "M", "T", "W", "T", "F", "S"] : ["D", "S", "T", "Q", "Q", "S", "S"],
        monthNames: lang == "en" ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] : ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        onChangeMonthYear: (year, month, datepickerObject) => {
            let afterDate = new Date(year, month - 1);
            let beforeDate = new Date(year, month + 2);

            calendarBody.date_query = JSON.stringify({
                after: {
                    year: afterDate.getFullYear(),
                    month: afterDate.getMonth() + 1,
                },
                before: {
                    year: beforeDate.getFullYear(),
                    month: beforeDate.getMonth() + 1,
                },
            });

            getEvents(calendarBody).then((res) => {
                const calEvents = res.posts;

                setCalendarEvents(calEvents);
                $("#datepicker").datepicker("refresh");
            });
        },
        // beforeShowDay: (dayDate) => {
        //     let formated = dayDate.toLocaleString("en", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

        //     if (currEvents[formated]) {
        //         return [true, "has-event", currEvents[formated].join("<br>")];
        //     }

        //     return [false, "", ""];
        // },
        beforeShowDay: (dayDate) => {
            let day = String(dayDate.getUTCDate()).padStart(2, "0");
            let month = String(dayDate.getUTCMonth() + 1).padStart(2, "0");
            let year = dayDate.getUTCFullYear();
            let formated = `${day}/${month}/${year}`;
        
            if (currEvents[formated]) {
                return [true, "has-event", currEvents[formated].join("<br>")];
            }
        
            return [true, "", ""];
        }
    };

    $("#datepicker").datepicker(datepickerArgs);

    $(document).tooltip(toolTipConfig);

    $("#next, #prev").on("click", function (e) {
        $(".ui-datepicker-" + e.target.id).trigger("click");
    });
});
